// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const WebAppDraftStrategySchema = z.enum(['PER_ORIGIN','PER_APEX'] as const);

export type WebAppDraftStrategyType = `${z.infer<typeof WebAppDraftStrategySchema>}`

export default WebAppDraftStrategySchema;
